module.exports = __webpack_public_path__ + "static/media/ind_sideDoor.e27cbcdc.png";